import { EspaceClerc } from './EspaceClerc.js';

export const ecrans = { X11: EspaceClerc };
